import { Form } from 'antd';
import { useContext, useEffect, useState } from 'react';

import { useUpdateUserSettingsMutation } from '@app/api/User/api';
import { SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import type { NEmployees } from '@app/types/Employees';
import type { NUsers } from '@app/types/Users';

export const useEmployeeSettingsTab = (
  employee: NUsers.User | undefined,
  allSettings: NEmployees.ModelUserSettings | undefined
) => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { activeBranchId } = useUserPrint();
  const [updateUserSettings] = useUpdateUserSettingsMutation();

  const { showNotification } = useContext(NotificationContext);

  const [form] = Form.useForm();

  useEffect(() => {
    if (allSettings) {
      form.setFieldsValue({
        IsSkipRecordNotifications: !allSettings.IsSkipRecordNotifications,
        IsRecordStatusChanges: allSettings.IsRecordStatusChanges,
        IsAllRecordsStatusChanges: allSettings.IsAllRecordsStatusChanges,
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSettings]);

  const submitForm = async (values: {
    IsSkipRecordNotifications: boolean;
    IsRecordStatusChanges: boolean;
    IsAllRecordsStatusChanges: boolean;
  }) => {
    try {
      if (activeBranchId && employee) {
        setLoading(true);

        await updateUserSettings({
          ActiveBranchId: activeBranchId,
          data: {
            UserId: employee?.id,
            IsSkipRecordNotifications: !values.IsSkipRecordNotifications,
            IsRecordStatusChanges: values.IsRecordStatusChanges,
            IsAllRecordsStatusChanges: values.IsAllRecordsStatusChanges,
          },
        }).unwrap();

        showNotification('Настройки сотрудника обновлены успешно', SUCCESS);
      }
    } catch (error) {
      setError(handleCatchError(error));
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    submitForm,
    isLoading,
    error,
    setError,
  };
};
